<template>
    <div>
        <scale 
        :model_score="weight_score" 
        :model_comment="weight_comment" 
        :section="section" 
        :contents="contents"
        :title="title"></scale>
    </div>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            weight_score:[],
            weight_comment:[],
            na: 0,
            title:"Weights",
            contents:[
                {
                    question:"Are you lifting heavy objects on a daily basis?",
                    parts: ['Back', 'Neck']
                },
                {
                    question:"Are the weights above 30kg?",
                    parts: ['Back', 'Neck']
                },
                {
                    question:"Is there any walking involved with object lifting? (prolonged walking 30 mins or more)",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.weight_score.length; x++){
                if(this.weight_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.weight_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.weight_score.length != this.contents.length || this.weight_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    weight_score: this.weight_score,
                    weight_comment: this.weight_comment,
                    weight_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.weight_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>


